import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import medipuzzleHTTPMethods from "../../utils/medipuzzleHttp";
import toast from "../../utils/toast";
import SliderForm from "../Slider/AddSliderForm";

export default function AddSlider() {
  const navigate = useNavigate();

  const handleSliderSubmit = data => {
    medipuzzleHTTPMethods
      .POST_FILE("slider/create/", data)
      .then(response => {
        toast.success("Slider added successfully");
        navigate("../");
      })
      .catch(error => {
        toast.error(error.response ?? "");
      });
  };

  return (
    <div>
      <SliderForm handleClickSubmit={handleSliderSubmit} />
    </div>
  );
}
